import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

interface SettingsRecommendationsTdMultiRoomPricingRangeMinMaxLabelsSignature {
  Args: {};
}

const SettingsRecommendationsTdMultiRoomPricingRangeMinMaxLabels: TOC<SettingsRecommendationsTdMultiRoomPricingRangeMinMaxLabelsSignature> =
  <template>
    <div
      class="flex flex-col items-start"
      data-test-id="td-multi-room-pricing-range-min-max-labels"
    >
      <p class="label text-200--bold">
        {{t "general.minimum.short"}}
      </p>
      <p class="label text-200--bold">
        {{t "general.maximum.short"}}
      </p>
    </div>
  </template>;

export default SettingsRecommendationsTdMultiRoomPricingRangeMinMaxLabels;
